import { useEffect } from 'react'
import { Banner, Page, Icon, BlockStack } from '@shopify/polaris';
import { ExternalSmallIcon } from '@shopify/polaris-icons';
import useAuthenticatedFetch from '../hooks/useAuthenticatedFetch';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Routes, useLocation } from "react-router-dom";
import UserGuide from '../containers/UserGuide';
import Shippings from "../containers/Shippings";
import ShippingSettings from "../components/ShippingSettings";
import Navbar from '../components/Navbar';
import { ShowMessage, setToast } from "../store/actions/configActions";
import Plans from '../components/Plans';
import FreeShippingRules from '../components/FreeShippingRules';
import './style.css'
import Loader from '../components/Loader';
import MoreApps from '../containers/MoreApps';
import OurMoreApps from '../containers/OurMoreApps';
import Eligibility from '../containers/Eligibility';
import CalloutVideoCard from '../components/CalloutVideoCard';
import Tutorials from '../containers/Tutorials';
import DefaultPrice from '../components/DefaultPrice';
import CCSWarning from '../components/CCSWarning';
import Home from '../containers/Home';
import { APP_PATH } from '../appConfig';

const path = APP_PATH

const AppRouter = props => {
    const location = useLocation()
    const { ConfigReducer, ShippingReducer } = useSelector(state => state)
    const { activePlan, phone } = ConfigReducer
    const { shippingFetching, shippingList } = ShippingReducer
    const dispatch = useDispatch()
    const fetchJson = useAuthenticatedFetch()
    const appName = APP_PATH
    const dynamicShopName = ConfigReducer.shopName || ConfigReducer.store?.domain?.replace('.myshopify.com', '')
    const shopifyManagedPricingUrl = `https://admin.shopify.com/store/${dynamicShopName}/charges/${appName}/pricing_plans`

    const redirectUrl = `/auth?shop=${ConfigReducer.store.domain}&host=${ConfigReducer.host}`

    useEffect(() => {
        if (ConfigReducer.show_message) {
            dismissBanner(false)
        }
    }, [ConfigReducer.show_message])

    useEffect(() => {
        if (!shippingFetching && !ConfigReducer.store.plan_id && dynamicShopName) {
            window.top.location.href = shopifyManagedPricingUrl
        }
    }, [shippingFetching, ConfigReducer.store.plan_id, dynamicShopName, shopifyManagedPricingUrl])

    const dismissBanner = (updateReducer = true) => {
        fetchJson(`/settings/dismiss`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ shop_id: ConfigReducer.shop_id, show_message: false })
        }).then(response => {
            if (response?.status >= 500) {
                dispatch(setToast({ "active": true, "content": "Server Error", error: true }))
            } else {
                if (response?.[0] && updateReducer) {
                    dispatch(ShowMessage(false))
                }
            }
        }).catch(error => {
            dispatch(setToast({ "active": true, "content": error.message, "error": true }))
        })
    }
    const navOptions = [
        {
            text: "Home",
            url: "/",
        },
        {
            text: "Shipping Rates",
            url: "/rates",
        },
        {
            text: "Free Shipping Rules",
            url: "/free_shipping_rules",
        },
        {
            text: "Fallback Rate",
            url: "/default-price",
        },
        // {
        //     text: "User Guide",
        //     url: "/guide",
        // },
        // {
        //     text: "Tutorials",
        //     url: "/tutorials",
        // },
        // {
        //     text: "Eligibility",
        //     url: "/eligibility",
        // },
        {
            text: "More Apps",
            url: `/moreapps/${path}`,
        },
        {
            text: "Plans",
            url: "/plans",
            right: true,
            primary: true
        },
        {
            text: <span style={{ display: 'flex', alignItems: 'center' }}>Help Center <div className='help-center-icon'><Icon source={ExternalSmallIcon} /></div></span>,
            url: `https://api.whatsapp.com/send/?phone=923067733666`,
            right: true,
            external: true
        },
    ]


    if (!shippingFetching && !ConfigReducer.store.plan_id && dynamicShopName) {
        return <Loader />
    }

    return (
        shippingFetching ? <Loader /> : <div>
            {ConfigReducer.store.plan_id ? <Navbar options={navOptions} /> : null}
            {ConfigReducer.show_message ? <Page>
                <Banner
                    title={`${activePlan.name} plan is activated successfully. Turn on your shipping rates.`}
                    status="success"
                    onDismiss={dismissBanner}
                />
            </Page> : null}
            {props.scopes ? <Page>
                <Banner
                    title="Permission Access Request"
                    action={{
                        content: 'Allow',
                        url: redirectUrl,
                        external: true
                    }}
                    status="critical"
                >
                    <p>
                        "Hi there! We value your privacy and want to ensure that we're providing you with the best experience possible. To do this, we'd like to ask for your permission to read your locations that will help us improve our services. Your personal information will be kept secure and used solely to provide you best services. Please click 'Allow' to give us your consent. Thank you for your cooperation!"
                    </p>
                </Banner>
            </Page> : null
            }
            {(ConfigReducer.warning && location.pathname !== "/plans" && shippingList.length) ? <Page>
                <BlockStack gap={300}>
                    {/* <CalloutVideoCard /> */}
                    <CCSWarning />
                </BlockStack>
            </Page> : null
            }

            <Routes>
                <Route path="/" element={<Home />} />
                <Route exact path="/rates" element={<Shippings />} />
                <Route exact path="/rates/new" element={<ShippingSettings />} />
                <Route exact path="/rates/:id" element={<ShippingSettings />} />
                <Route exact path="/free_shipping_rules" element={<FreeShippingRules />} />
                <Route exact path="/default-price" element={<DefaultPrice />} />
                {/* <Route exact path="/plans" element={<Plans />} /> */}
                <Route exact path="/tutorials" element={<Tutorials />} />
                {/* <Route exact path="/guide" element={<UserGuide />} /> */}
                {/* <Route exact path="/eligibility" element={<Eligibility />} /> */}
                <Route exact path="/apps" element={<MoreApps />} />
                <Route exact path="/moreapps/:path" element={<OurMoreApps />} />
            </Routes>
        </div>
    )
}

export default AppRouter;




